<template>
  <div>
    <!-- banner -->
    <sbanner :detailInfo="{}">
      <template v-slot:searchBox>
        <div class="search-con2">
          <span class="iconfont icon-search"></span>
          <input type="text" placeholder="" v-model="keyword" ref="inputs" />
          <span class="search-btn" @click="searchList">搜索</span>
        </div>
      </template>
    </sbanner>

    <div class="search-detail">
      <div class="container">
        <div class="search-left">
          <h1>结果筛选</h1>
          <!-- id: 1, name: '节目库', cateId: '3', path: '/program', api: 'jmkApi', columnsType: 'jmkcate', storeName: 'SearchProgram', children: -->
          <template v-for="(item, index) in filterList">
            <slide-drop
              v-if="item.valid"
              :key="index"
              :row="item"
              :base="filterList"
              :index="index"
              @changeCol="onChangeCol"
              @change="onChangeFilter"
            />
          </template>
        </div>
        <div class="search-right">
          <div class="choosed" v-if="showSelected">
            <em>已选择</em>
            <template v-for="(item, index) in selectObj">
              <p :key="index" v-if="item.id && item.id != -1 && item.id != '全部'">
                <span>{{item.name}}</span>
                <em class="iconfont icon-close-fill" @click="delectLabel(item.type, index)"></em>
              </p>
            </template>
          </div>
          <h2 class="title">找到相关结果 <span>{{ listTotal }}</span> 条</h2>
          <div class="search-list" v-if="list && list.length > 0">
            <template v-for="item in list">
              <search-item :item="item" :showpath="showpath" :keyword="keyword" />
            </template>
          </div>

          <empty v-if="list && list.length == 0 && !isFirstLoading">
            <template v-slot:emptyTips>
              <div class="empty-txt">没有更多了</div>
            </template>
          </empty>

          <loading v-show="showLoading" />
        </div>

      </div>
      <!-- 分页器 -->
      <Pagination :total="listTotal" :curPage="pageIndex" :pageSize="pageSize" @clickPage="clickPage"
        v-if="listTotal > 0" />
      <!-- 分页器 -->
    </div>

  </div>
</template>

<script>
import Sbanner from '../components/sbanner.vue'
import Pagination from '../components/pagination.vue'
import SearchItem from '../components/listModel/searchItem.vue'
import colums from '../colums/colums.js'
import area from '@/config/area.js';
import Empty from '../components/common/empty.vue'
import Loading from '../components/common/loading.vue'
import slideDrop from '../components/common/slideDrop.vue'
import { mapState, mapActions, mapMutations } from 'vuex'
import { treeToList } from "@/utils/tools"
import Hash from "@/mixin/hash";

const defaultFilter = [
  { id: 'program', name: '节目库', searchtype: 3, children: [], value: '', type: 'hasAward', hide: [], valid: true, isShow: true, path: '/program', api: 'jmkApi', columnsType: 'jmkcate' },
  { id: 'exhibit', name: '展品库', searchtype: 7, children: [], value: '', type: 'hasAward', hide: [], valid: true, isShow: false, path: '/exhibit', api: 'exhibitApi', columnsType: 'exhibitCate', params: {
    is_award: -1,
    is_check: -1,
    is_top: -1,
    recommend: -1,
  } },
  { id: 'literature', name: '文学库', searchtype: 6, children: [], value: '', type: 'hasAward', hide: [], valid: true, isShow: false, path: '/literature', api: 'literatureApi', columnsType: 'literatureCate', params: {
    is_award: -1,
    is_check: -1,
    is_top: -1,
    recommend: -1,
  } },
  { id: 'activity', name: '活动库', value: '', type: 'noAward', hide: [], valid: true, isShow: false, path: '/activity', api: '', children: [
    {
      id: '4_1',
      name: '专场活动',
      api: 'hdkApi',
      path: '/activity',
      searchtype: 2,
      value: '',
      params: {
        brand_id: -1,
        is_top: -1,
        level: -1,
        recommend: -1
      }
    }, {
      id: '3_1',
      name: '专题活动',
      api: 'brandApi',
      path: '/thematic',
      searchtype: 1,
      value: '',
      params: {
        type_id: -1,
        is_award: -1
      }
    }
  ]},
  { id: 'artist', name: '人才库', searchtype: 5, children: [], value: '', type: 'noAward', hide: ['year'], valid: true, isShow: false, path: '/artist', api: 'artistApi' },
  { id: 'award', name: '获奖库', children: [], value: '', type: 'award', hide: [], valid: true, isShow: false, path: '', api: '' },
  { id: 'poster', name: '海报库', searchtype: 8, children: [], value: '', type: 'noAward', hide: ['year'], valid: true, isShow: false, path: '/poster', api: 'posterApi' },
  { id: 'city', name: '地区', children: [], value: '', type: 'checkbox', hide: [], valid: true, isShow: false, path: '', api: '' },
  { id: 'year', name: '日期', children: [], value: '', type: 'checkbox', hide: [], valid: true, isShow: false, path: '', api: '', class: "rank-year" },
]

export default {
  name: 'search',
  mixins: [Hash],
  components: {
    Sbanner,
    Pagination,
    SearchItem,
    Empty,
    Loading,
    slideDrop
  },
  computed: {
    ...mapState({
      jmkcate: state => state.jmkcate,
      exhibitCate: state => state.exhibitCate,
      literatureCate: state => state.literatureCate,
      awardCate: state => state.awardList,
      posterCate: state => state.posterCate,
      totalFilter: state => state.totalFilter
    }),

    artistCol() {
      let arr = colums.letters.map(a => {
        if (a == '全部') {
          return { name: a, id: '' }
        }
        return { name: a, id: a }
      })
      return arr;
    },
    areaCol() {
      let newArea = area.gdData2.map(item => {
        return { name: item.name, id: item.name == '全部' ? '' : item.name }
      })
      return newArea;
    },
  },
  data() {
    return {
      showpath: "",
      showLoading: false,
      keyword: '',
      filterList: [],
      selectObj: {
        arow: { id: '', name: '', type: ''},
        award: { id: '', name: '', type: ''},
        city: { id: '', name: '', type: ''},
        year: { id: '', name: '', type: ''}
      },
      pageSize: 20,
      listTotal: 0,
      pageIndex: 1,
      list: [],
      colOpen: {},
      query: {},
      isFirstLoading: true,
      params: {},
      currApi: '',
      showSelected: false,
      currSearchtype: 1,
      allTypeList: []
    }
  },
  mounted() {
    this.query = this.$route.query;
    this.initPage();
    this.focusBtn();
  },
  methods: {
    async initPage() {
      this.filterList = JSON.parse(JSON.stringify(defaultFilter))

      let type = ''
      if (this.query.type) {
        const row = this.filterList.find(v => v.id == this.query.type) || {}
        type = row.searchtype
      }
      this.$api.recordApi.addListRecord('搜索', type);

      // 第一次进来，没有参数，所以先加载列表，再加载侧边筛选项
      if (JSON.stringify(this.query) == '{}') {
        this.searchAll()
      }

      if (this.totalFilter && this.totalFilter.length) {
        this.filterList = this.totalFilter
      } else {
        if (!this.awardCate || !this.awardCate.length) {
          await this.getWardList()
        }
        if (!this.posterCate || !this.posterCate.length) {
          await this.getPosterCate()
        }
        const awardCate = this.awardCate || []
        // 填充筛选项
        const filters = this.filterList.map(async v => {
          if (v.id == 'program') {  // 节目库
            v.children = await this.getChannelCate(v.columnsType)
          } else if (v.id == 'exhibit') {   // 展品库
            v.children = await this.getExhibitSubCate(v.columnsType)
          } else if (v.id == 'literature') {   // 文学库
            v.children = await this.getLiteratureSubCate(v.columnsType)
          } else if (v.id == 'artist') {   // 人才库
            v.children = this.getAllLetters()
          } else if (v.id == 'award') {  // 获奖库
            v.children = awardCate.map(v => {
              v.id = v.id || v.name
              return {
              ...v
              }
            })
          } else if (v.id == 'poster') {  // 海报库
            v.children = this.posterCate
          } else if (v.id == 'city') {  // 城市
            v.children = this.areaCol.map(v => {
              if (v.id == '全部地区') {
                v.id = '-1'
                v.name = '全部'
              }
              return {
                ...v
              }
            })
          } else if (v.id == 'year') {  // 年份
            v.children = await this.getYearSelect()
          }
        })
        await Promise.all(filters)
      }
      this.allTypeList = treeToList(this.filterList)
      this.updateCateByName({list: this.filterList, name: 'totalFilter'});
      // 有筛选参数时，加载完了筛选项再初始化参数，再加载列表
      this.loadData()
    },
    loadData() {
      const query = JSON.parse(JSON.stringify(this.query))
      this.resetFilterValue(this.filterList)

      if (query) {
        let row = this.filterList.find(v => v.id == query.type) || {}
        let hideList = row.hide || []

        if (query.keyword) {
            this.keyword = query.keyword.trim()
        }
        if (query.page) {
          this.pageIndex = parseInt(Math.max(0, query.page)) || 1
        }

        const col = query.col || this.filterList[0].id
        this.filterList.forEach(v => {
          v.valid = !hideList.includes(v.id)
          v.isShow = col.includes(v.id)
        })
      }
      
      this.setParams()

      if (JSON.stringify(this.query) != '{}') {
        if (this.currApi) {
          this.getList()
        } else {
          this.searchAll()
        }
      }
    },
    setParams() {
      const query = JSON.parse(JSON.stringify(this.query))
      let params = {}
      if (this.keyword) {
        params.keywords = this.keyword
      }
      
      if (query.type && query.value) {
        // 查找出URL中 type 对应的分类
        let row = this.filterList.find(v => v.id == query.type) || {}
        const valArr = query.value ? query.value.split(',') : []
        this.setChildValue(row, valArr)
        // 取出分类的查询参数
        if (query.type == 'activity') {
          row = row.children.find(v => v.id == query.value)
        }
        if (row.params) {
          params = {
            ...params,
            ...row.params
          }
        }
        // 取出分类的api
        if (row.api) {
          this.currApi = row.api
        }
        // 取出分类的searchtype
        if (row.searchtype) {
          this.currSearchtype = row.searchtype
        }
        const val = query.value ? query.value.split(',') : []
        const cateId = val[0] || ''
        const subId = val[1] || ''
        switch(query.type) {
          case 'program':
            params.type_id = cateId
            if (subId) {
              params.type_tag = subId
            }
            break;
          case 'exhibit':
          case 'literature':
            params.category = cateId
            if (subId) {
              params.typeid = subId
            }
            break;
          case 'artist':
            params.firstCode = cateId == -1 ? '' : cateId
            break;
          case 'poster':
            params.typeid = cateId
            break;
        }
      } else {
        this.currSearchtype = 3
      }
      if (query.city) {
        params.city = query.city && query.city != '全部地区' ? query.city : ''
        const cityRow = this.filterList.find(v => v.id == 'city') || {}
        const valArr = [query.city]
        this.setChildValue(cityRow, valArr)
        if (params.city == -1) {
          delete(params.city)
        }
      }
      if (query.year) {
        params.task_year = query.year
        const yearRow = this.filterList.find(v => v.id == 'year') || {}
        const valArr = [query.year]
        this.setChildValue(yearRow, valArr)
        if (params.task_year == -1) {
          delete(params.task_year)
        }
      }
      if (query.award) {
        params.award = query.award == '全部' ? '' : query.award
        params.is_award = 1
        const awardRow = this.filterList.find(v => v.id == 'award') || {}
        const valArr = [query.award]
        this.setChildValue(awardRow, valArr)
      }
      this.params = params

// console.log('this.selectObj: ', JSON.parse(JSON.stringify(this.selectObj)))
// console.log('query: ', JSON.parse(JSON.stringify(query)))

      if (this.selectObj.award.id && !this.currApi) {
        this.currApi = this.filterList[0].api
      }
      let showSelected = false
      for (let i in this.selectObj) {
        if (this.selectObj[i].id && this.selectObj[i].id != -1 && this.selectObj[i].id != '全部') {
          showSelected = true
        }
      }
      this.showSelected = showSelected
    },
    resetFilterValue(list) {
      if (list && list.length) {
        list.forEach(v => {
          v.value = ''
          this.resetFilterValue(v.children)
        })
      }
    },
    setChildValue(row, value) {
      if (row.children && row.children.length) {
        row.children.forEach(v => {
          if (value.includes(v.id.toString())) {
            const obj = {
              id: v.id,
              name: v.name,
              type: row.id
            }
            if (row.id == 'city') {
              this.selectObj.city = obj
            } else if (row.id == 'award') {
              this.selectObj.award = obj
            } else if (row.id == 'year') {
              this.selectObj.year = {
                ...obj,
                name: obj.name + '年'
              }
            } else {
              this.selectObj.arow = obj
            }
            row.value = v.id
          }
          this.setChildValue(v, value)
        })
      }
    },
    //自动聚集input表单
    focusBtn() {
      this.$nextTick(() => {   //正确写法
        this.$refs.inputs.focus();
      })
    },
    //点击搜索按钮，搜索列表
    searchList() {
      this.setLocationQuery({
        keyword: this.keyword,
        page: 1,
        _: parseInt(Math.random() * 1000000)
      })
    },
    //获取筛选的年份
    async getYearSelect() {
      let params = {
        categoryid: 1,
      }
      const res = await this.$api.yearApi.getMinYear(params)
      let minYear = res.data;
      let maxYear = new Date().getFullYear();
      let arr = []
      for (let i = minYear; i <= maxYear; i++) {
        arr.unshift({
          name: i, id: i
        })
      }
      arr.unshift({ name: '全部', id: '-1' })
      return arr;
    },

    //获取节目分类及二级分类并更新到store中
    async getChannelCate(columnsType) {
      let arr = []
        for (let item of colums[columnsType]) {
          const res = await this.$api.channelApi.getChannel({ parentId: item.labelid });
          const list = res.data || []
          let thirdLevel = false;
          let child = list.map(v => {
            return {
              name: v.name, 
              id: v.id,
              value: ''
            }
          })
          let newFun = []
          child.map(t => { newFun.push(this.$api.channelApi.getChannel({ parentId: t.id })) })
          let res2 = await Promise.all([...newFun])
          res2.map((t, i) => {
            const subArr = t.data.map(t2 => {
              return {
                name: t2.name, 
                id: t2.id,
                value: ''
              }
            })
            child[i].children = subArr
            if (subArr && subArr.length > 0) {
              thirdLevel = true
            }
          })
          arr.push({ name: item.name, id: item.id, children: child, value: '', thirdLevel })
        }
        arr.unshift({ name: '全部', id: -1 });
      console.log('arr: ' + columnsType, arr)
        this.updateCateByName({list: arr, name: columnsType});

      return arr
    },
    async getExhibitSubCate(columnsType) {
      let arr = JSON.parse(JSON.stringify(colums[columnsType])) || [];
      const res = await this.$api.exhibitApi.getCateList()
      arr.forEach((v, i) => {
        const list = res[`data${i + 1}`]
        if (list && list.length) {
          v.children = list
        }
      })
      arr.unshift({ name: '全部', id: -1 });
      this.updateCateByName({list: arr, name: columnsType});
      return arr
    },
    async getLiteratureSubCate(columnsType) {
      let arr = JSON.parse(JSON.stringify(colums[columnsType])) || [];
      const res = await this.$api.literatureApi.getCateList()
      arr.forEach((v, i) => {
        const list = res[`data${i + 1}`]
        if (list && list.length) {
          v.children = list
        }
      })
      arr.unshift({ name: '全部', id: -1 });
      this.updateCateByName({list: arr, name: columnsType});
      return arr
    },
    // 获取A-Z字母
    getAllLetters() {
      return colums.letters.map(a => {
        if (a == '全部') {
          return { name: a, id: -1 }
        }
        return { name: a, id: a }
      })
    },
    //没有选择条件的时候，直接搜索结果
    async searchAll() {
      this.list = null;
      this.showLoading = true;
      let params = {
        ...this.params,
        page: this.pageIndex,
        pageSize: this.pageSize,
        keywords: this.keyword,
      }
      const res = await this.$api.searchAllApi.getSearchAll(params)
      this.showpath = res.showpath;
      this.list = res.data.map(v => {
        if (!v.type_name && v.subtype_id) {
          const row = this.allTypeList.find(vv => vv.id == v.subtype_id) || {}
          v.type_name = row.name
        }
        return {
          ...v
        }
      });
      this.listTotal = res.total;
      this.showLoading = false;
      this.isFirstLoading = false
    },
    //通过关键字及筛选条件获取结果
    getList() {
      //根据不同的条件请求不同接口
      this.list = null;
      this.showLoading = true;

      let params = {
        ...this.params,
        page: this.pageIndex,
        pageSize: this.pageSize,
      }
      for (let k in params) {
        if (!params[k]) {
          delete(params[k])
        }
      }
      this.$api[this.currApi].getList(params).then(res => {
        this.showpath = res.showpath;
        const list = res.data.map(v => {
          return {
            ...v,
            searchtype: this.currSearchtype
          }
        });
        this.list = list;
        this.showLoading = false;
        this.listTotal = res.total;
      })
    },
    // 分页跳转
    clickPage(info) {
      if (info.topage > 0) {
        this.pageIndex = info.topage;
        if (this.pageIndex > 1) {
          this.setLocationQuery('page', this.pageIndex)
        } else {
          this.removeLocationQuery('page')
        }
      }
    },
    onChangeCol(index) {
      this.filterList[index].isShow = !this.filterList[index].isShow
    },
    // 筛选结果拼装hash
    onChangeFilter({ids, index}) {
      const query = {
        page: 1
      }
      
      const oldQuery = JSON.parse(JSON.stringify(this.query))
      const keyword = this.keyword.trim()
      if (keyword) {
        query.keyword = keyword
      }
      // 获取展开项的hash，插入query对象
      const col = this.filterList.filter(v => v.isShow).map(v => v.id)
      const base = this.filterList[index] || {}
      if (base.type == 'hasAward' || base.type == 'noAward') {
        // 如果搜索类型相同，只改value和col值，保留获奖，城市，年份参数
        if (oldQuery.type == base.id) {
          query.value = ids
          if (col && col.length) {
            query.col = col.join(',')
          }
          this.setLocationQuery(query)
        } else {
          query.type = base.id
          query.value = ids
          if (base.hide) {
            base.hide.forEach(v => {
              query[v] = ''
            })
          }
          if (col && col.length) {
            query.col = col.join(',')
          }
          this.resetLocationQuery(query)
        }
      } else {
        query[base.id] = ids
        let reset = false
        if (base.type == 'award') {
          const oldBase = this.filterList.find(v => v.id == oldQuery.type) || {}
          if (oldBase.type != 'hasAward') {
            query.type = this.filterList[0].id
            query.value = ''
            reset = true
          }
        }
        if (col && col.length) {
          query.col = col.join(',')
        }
        if (reset) {
          this.resetLocationQuery(query)
        } else {
          this.setLocationQuery(query)
        }
      }
    },
    getChildrenValue(list, valList) {
      if (list && list.length) {
        list.forEach(v => {
          if (v.value) {
            valList.push(v.value)
          }
          this.getChildrenValue(v.children, valList)
        })
      }
      return valList
    },
    delectLabel(type, index) {
      if (index == 'arow') {
        this.removeLocationQuery(['type', 'value']);
      } else {
        this.removeLocationQuery(type);
      }
    },
    ...mapActions([
      "getDutyList",
      "getWardList",
      "getPosterCate"
    ]),
    ...mapMutations([
      "updateCateByName"
    ]),
  },
}
</script>